import { Flex, Text, Link, VStack } from '@chakra-ui/react';

function Footer() {
    return (
        <Flex justifyContent="center" 
              alignItems="center" 
              bgColor="#282c34" >

            <VStack textAlign="center" color="white" spacing="0px">
                <Text fontSize="10px" mt={2}>8F, S16-H105, 10, Chungmin-ro, Songpa-gu, Seoul, Republic of Korea</Text>
                <Text fontSize="10px">Business Registration Number: 479-23-02071</Text>
                {/* <Text fontSize="10px">E-commerce Registration Number: 2024-SeoulSongpa-3542</Text> */}
                <Text fontSize="10px">Email: support@dodo-dot.com</Text>
                <Link rel="canonical" fontSize="12px" href="https://www.dodo-dot.com/privacy-policy" color="white" fontWeight="semibold" mb={2}>
                    Privacy Policy
                </Link>
            </VStack>
            
        </Flex>
    );
}

export default Footer;